import React from 'react';
import './header.scss';

const Header = () => {
  return (
    <header className="header-main">
      <h1 className="container header-main__text">
        Тестовое задание Middle React Dev
      </h1>
    </header>
  );
};

export default Header;
